import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'

type Refresh = () => void

interface RetriveItemReservationParams {
  hashItemReserve: string
  nameReserve: string
  refresh: Refresh
  notify: any
  setLoadingRetriveItem: React.Dispatch<React.SetStateAction<boolean>>
  setNameReserve: React.Dispatch<React.SetStateAction<string>>
  setHashItemReserve: React.Dispatch<React.SetStateAction<string>>
  setConfirmRetrive: React.Dispatch<React.SetStateAction<boolean>> | undefined
  setOpenRetriveModal: React.Dispatch<React.SetStateAction<boolean>> | undefined
}

export const retriveItemReservation = async ({
  hashItemReserve,
  nameReserve,
  refresh,
  notify,
  setHashItemReserve,
  setLoadingRetriveItem,
  setNameReserve,
  setConfirmRetrive,
  setOpenRetriveModal,
}: RetriveItemReservationParams): Promise<void> => {
  try {
    setLoadingRetriveItem(true)
    setOpenRetriveModal && setOpenRetriveModal(false)
    const response = await itemServices.retrieve_item(hashItemReserve)
    if (response) {
      notify('ra.notification.retrive_item_reserve_success', {
        type: 'success',
        messageArgs: { reserve: nameReserve },
      })
      setNameReserve('')
      setHashItemReserve('')
      setConfirmRetrive && setConfirmRetrive(false)
      return
    }
    setNameReserve('')
    setHashItemReserve('')
    setConfirmRetrive && setConfirmRetrive(false)
    setLoadingRetriveItem(false)
    notify('ra.notification.retrive_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
  } catch (error) {
    console.log('error', error)
    notify('ra.notification.retrive_item_reserve_error', {
      type: 'error',
      messageArgs: { reserve: nameReserve },
    })
    setOpenRetriveModal && setOpenRetriveModal(false)
    setNameReserve('')
    setHashItemReserve('')
    setLoadingRetriveItem(false)
    setConfirmRetrive && setConfirmRetrive(false)
  } finally {
    customAwait([refresh])
    setOpenRetriveModal && setOpenRetriveModal(false)
    setLoadingRetriveItem(false)
  }
}
